// @flow

/**
 * Map of the link `target` attributes used for different purposes
 */
const linkTargets = {
  ageUK:     'ageUK',
  email:     'email',
  reference: 'reference',
  service:   'service',
  sail:      'sail',
  sponsor:   'sponsor',
};


export default linkTargets;



// WEBPACK FOOTER //
// ./src/config/linkTargets.js